import axios from 'axios';

export default {
    name: 'search',
    component() {
        return {
          searchVal: (() => {
                const urlParams = new URLSearchParams(window.location.search);
                return urlParams.get('q') || '';
            })(),
            
            init() {
                // this.$watch("searchVal", (val) => {
                //     console.log(val);
                //     if (val || val == "") {
                //         this.startSearch();
                //     }
                // });
            },

            // startSearch() {
            //     const filters = new FormData(document.getElementById('search-filters'));
            //     const params = new URLSearchParams();
            
            //     // Append all the form data to the URL parameters
            //     filters.forEach((value, key) => {
            //       params.append(key, value);
            //       // console.log(params);
            //     });
            
            //     // Make the Axios request to fetch filtered search results

            //     axios.get('/search', { params: params })
            //       .then(function (response) {
            //         // If the request is successful, update the page with the new results
            //         const resultsContainer = document.getElementById('search-results');
            
            //         let div = document.createElement('div')
            //         div.innerHTML = response.data;

            //         // Update the search results HTML with the response data
            //         resultsContainer.innerHTML = div.querySelector('#search-results').innerHTML;

            //         div.remove();
            //       })
            //       .catch(function (error) {
            //         console.error('Error fetching search results:', error);
            //       });
            // }
        }
    }
}

